import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { StatCardWithProgress } from 'components/StatCard';
import { useRouter } from 'next/router';
import classNames from 'classnames';
import { useGetEventAnalytics } from 'legacy/events/hooks';
import DownloadCSVButton from '../DownloadCSVButton';
import EventRequestList from '../../EventRequestList';
import { EventForHost } from 'legacy/events/types';

const TicketingSection = ({
  event,
  onClickExportAnalytics,
  isFetchingExportAnalytics
}: {
  event: EventForHost;
  onClickExportAnalytics: () => void;
  isFetchingExportAnalytics: boolean;
}) => {
  const { t } = useTranslation(['events']);
  const router = useRouter();
  const eventId = router.query.slug as string;
  const { data: eventAnalytics } = useGetEventAnalytics(
    eventId,
    event.isOrganizer
  );

  const hasRequestList = useMemo(
    () =>
      event?.isOrganizer &&
      event?.pricing?.tiers?.find((tier) => tier.requiresApproval),
    [event?.isOrganizer, event?.pricing?.tiers]
  );

  return (
    <div>
      <div className="flex justify-between  mb-4 items-center">
        <h2 className="text-xl font-bold flex flex-row">
          <img src="/img/events/ticket.svg" alt="ticket" /> &nbsp;{' '}
          {t('events:dashboard.ticketing.title')}
        </h2>
        <div className="flex text-right">
          <DownloadCSVButton
            onClick={onClickExportAnalytics}
            loading={isFetchingExportAnalytics}
          />
        </div>
      </div>

      <div className="flex flex-row gap-4">
        {hasRequestList && (
          <div className="w-1/3">
            <EventRequestList
              eventId={eventId}
              requestListSummary={event.requestListSummary}
            />
          </div>
        )}
        <div
          className={classNames(
            'flex gap-4',
            hasRequestList ? 'w-2/3' : 'flex-1'
          )}
        >
          <div className="flex-1">
            <StatCardWithProgress
              label={t('events:dashboard.ticketing.admissionScanned')}
              value={`${eventAnalytics?.tickets?.admission?.scans}/${eventAnalytics?.tickets?.admission?.sales}`}
              progress={{
                value: eventAnalytics?.tickets?.admission?.scans,
                max: eventAnalytics?.tickets?.admission?.sales
              }}
            />
          </div>
          <div className="flex-1">
            <StatCardWithProgress
              label={t('events:dashboard.ticketing.addOnsScanned')}
              value={`${eventAnalytics?.tickets?.addon?.scans}/${eventAnalytics?.tickets?.addon?.sales}`}
              progress={{
                value: eventAnalytics?.tickets?.addon?.scans,
                max: eventAnalytics?.tickets?.addon?.sales
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TicketingSection;
